// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","price__popup":"price__popup-2JJJY","close":"close-19_i9"};